import type { SVGProps } from "react";
import { twMerge } from "tailwind-merge";

export default function ActionIcon({
  width = 24,
  height = 21,
  className,
}: Readonly<Pick<SVGProps<"svg">, "width" | "height" | "className">>) {
  return (
    <svg
      aria-hidden="true"
      width={width}
      height={height}
      className={twMerge("text-white", className)}
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.79468 20.5873C0.80218 20.5873 0.81118 20.5873 0.82018 20.5866C1.19968 20.5738 1.43893 20.2798 1.47118 19.9018C1.49668 19.6236 2.24368 12.8916 12.7504 12.8991L12.7744 17.2033C12.7744 17.4936 12.9417 17.7576 13.2042 17.8813C13.4637 18.0058 13.7772 17.9676 13.9999 17.7823L23.7259 9.72506C23.9007 9.58181 24.0004 9.36881 23.9997 9.14456C23.9989 8.92031 23.8977 8.70656 23.7237 8.56406L13.9984 0.58181C13.7742 0.39881 13.4644 0.36356 13.2027 0.48581C12.9409 0.61031 12.7737 0.87431 12.7737 1.16306L12.7497 5.37356C8.39143 5.51156 5.01568 6.91331 2.82793 9.47381C-0.73307 13.6408 0.0619299 19.6963 0.0986799 19.9483C0.15418 20.3158 0.42343 20.5858 0.79318 20.5858L0.79468 20.5873ZM13.5244 11.3878H13.5229C6.01768 11.3923 3.14968 13.9266 1.51168 16.1653C1.75168 14.3728 2.45068 12.2106 3.97243 10.4458C5.99593 8.09981 9.25618 6.86306 13.5244 6.86306C13.9384 6.86306 14.2744 6.52781 14.2744 6.11306V2.74331L22.0662 9.14981L14.2744 15.6163V12.1386C14.2744 11.9398 14.1957 11.7486 14.0539 11.6076C13.9137 11.4673 13.7232 11.3878 13.5244 11.3878Z"
        fill="currentColor"
      />
    </svg>
  );
}
